// extracted by mini-css-extract-plugin
export var fadeInAnimation = "IssueIntroduction-module--fadeInAnimation--mCw+Q";
export var fadeOutAnimation = "IssueIntroduction-module--fadeOutAnimation--lMtms";
export var issueIntroduction = "IssueIntroduction-module--issueIntroduction--C4IAn";
export var slideIn = "IssueIntroduction-module--slideIn--MUEXn";
export var slideInMobileNav = "IssueIntroduction-module--slideInMobileNav--098kK";
export var slideInNav = "IssueIntroduction-module--slideInNav--ZRcft";
export var slideInTop = "IssueIntroduction-module--slideInTop--KRadu";
export var slideOut = "IssueIntroduction-module--slideOut--2lye+";
export var slideOutTop = "IssueIntroduction-module--slideOutTop--CqfDX";